<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="codigo" class="block text-sm font-medium text-gray-700">Código del contrato</label>
      <input type="number" id="codigo" :value="loadData.codigo"
             @change="(newContrato)=>$emit('updateValues', {'codigo': customUpdateValueData('codigo', newContrato.target.value)})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="concepto" class="block text-sm font-medium text-gray-700">Concepto</label>
      <textarea id="concepto" :value="loadData.concepto" rows="4"
                @change="(newConcepto)=>$emit('updateValues', {'concepto': customUpdateValueData('concepto', newConcepto.target.value)})"
                class="block p-2.5 w-full text-sm rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"></textarea>
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="valor" class="block text-sm font-medium text-gray-700">Valor </label>
      <input  id="valor" type="number"  :value="loadData.valor"
             @change="(newValor)=>$emit('updateValues', {'valor':customUpdateValueData('valor',newValor.target.value)})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContratosCrearActualizarComponent',
  props: ['loadData', 'collectionContratistas', 'customUpdateValueData'],
  emits: ["updateValues"],
}
</script>